import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-spcod/room/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/park-spcod/room/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/park-spcod/room/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/park-spcod/room/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/park-spcod/room/submit',
    method: 'post',
    data: row
  })
}



export const addCompanyRoom = (data) => {
  return request({
    url: '/api/park-company/companycheckin/addCompanyRoom',
    method: 'post',
    params: data
  })
}

export const delCompanyRoom = (data) => {
  return request({
    url: '/api/park-company/companycheckin/delCompanyRoom',
    method: 'post',
    params: data
  })
}
